import ApplicantsToReviewItem from './ApplicantsToReviewItem';
export default ApplicantsToReviewItem;
